import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { SubCategoryPage } from "@/features/mbc-admin/subcategories/SubCategoryPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/admin/subcategories/$subCategoryId",
)({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Subcategory");
  const { subCategoryId } = Route.useParams();

  return <SubCategoryPage subCategoryId={Number(subCategoryId)} />;
}
